const moment = require('moment-timezone');
import firebase from '../firebase/firebase';
const db = firebase.database();

const checkServiceStatus = (filteredServices, service) => {
    let doesStatusExistOnService = false;
    filteredServices.map(filteredService => {
        if (filteredService._id === service._id) doesStatusExistOnService = true;
    });
    return doesStatusExistOnService;
}

export const checkIfServiceIncludesStatuses = (service, statusesToCheck, {
    activeServices,
    inactiveServices,
    pendingServices
}) => {
    // statusesToCheck IS AN ARRAY OF EITHER 'active', 'pending' or 'inactive'

    let hasActive = false;
    let hasPending = false;
    let hasInactive = false;
    // console.log('STATUSES TO CHECK', statusesToCheck);

    if (statusesToCheck.includes('active')) hasActive = checkServiceStatus(activeServices, service);

    if (statusesToCheck.includes('pending')) hasPending = checkServiceStatus(pendingServices, service);

    if (statusesToCheck.includes('inactive')) hasInactive = checkServiceStatus(inactiveServices, service);

    return hasActive || hasPending || hasInactive;
}

const checkReceiverStatus = (filteredReceivers, receiver) => {
    // console.log('FILTERED RECEIVERS @ CHECKSTATUS', filteredReceivers);
    if (filteredReceivers && filteredReceivers.length > 0) {
        let doesStatusExistOnReceiver = false;
        filteredReceivers.map(filteredReceiver => {
            const doesReceiverMatch = (filteredReceiver && filteredReceiver._id && filteredReceiver._id === receiver._id) || (filteredReceiver && filteredReceiver.uid && filteredReceiver.uid === receiver.uid);
            if (doesReceiverMatch) doesStatusExistOnReceiver = true;
        });
        return doesStatusExistOnReceiver;
    }
    return false;
}

export const checkIfReceiverIncludesStatuses = (receiver, statusesToCheck, {
    activeReceivers,
    inactiveReceivers,
    pendingReceivers
}) => {
    // statusesToCheck is an array of either 'active', 'pending' or 'inactive'
    // console.log('STATUSES TO CHECK', statusesToCheck);

    let hasActive = false;
    let hasPending = false;
    let hasInactive = false;

    if (statusesToCheck.includes('active')) hasActive = checkReceiverStatus(activeReceivers, receiver);

    if (statusesToCheck.includes('pending')) hasPending = checkReceiverStatus(pendingReceivers, receiver);

    if (statusesToCheck.includes('inactive')) hasInactive = checkReceiverStatus(inactiveReceivers, receiver);

    return hasActive || hasPending || hasInactive;
}

export const handleMaplePurchase = (tax, userId, serviceId) => {
    // console.log('NOW RUNNING MAPLE PURCHASE CALL TO SECURE BACKEND');

    const purchasesRef = db.ref(`payments`);
    const purchasesKey = purchasesRef.push().key;
    purchasesRef.child(`${userId}/${purchasesKey}`).set({
            isComplete: false,
            serviceId,
            tax,
            type: 'maple',
        })
        .then(() => {
            // console.log('PAYMENT SENT FOR MAPLE PURCHASE');

        })
        .catch(console.log)
}

export const getActivePeriodTimestampsWithProgress = (activePeriods) => {
    let activePeriodsInfo = {};
    // console.log('activePeriodsInfo', activePeriodsInfo)
    if (activePeriods && activePeriods.length > 0) {
        activePeriodsInfo = activePeriods.map(activePeriod => {
            const activePeriodStart = activePeriod.utcActivePeriodStartTimestamp;
            const activePeriodEnd = activePeriod.utcActivePeriodEndTimestamp;
            const userMoment = moment.utc().format('x');
            const duration = (activePeriodEnd - activePeriodStart);

            const startToUserMoment = (userMoment - activePeriodStart);

            const activePeriodPercentage = ((startToUserMoment / duration) * 100)

            return {
                activePeriodStart: activePeriodStart,
                activePeriodEnd: activePeriodEnd,
                activePeriodPercentage: activePeriodPercentage
            }
        })
    }
    return activePeriodsInfo
}


// WEBPACK FOOTER //
// ./src/js/utils/serviceUtils.js